<template>
  <div>
    <div :class="{ 'my-progress': true, 'progress-show': pro_show}">
      <el-progress type="circle" :percentage="cur_per" class="progress-circle"></el-progress>
    </div>
    <div class='social-bg' v-show="$i18n.locale==='zh'">
      <el-image :src="campus_header" style=" width: 100%; margin-bottom: 3%"></el-image>
      <el-image :src="social_title" style=" width: 100%; margin-bottom: 3%"></el-image>
      <div class='campus-list'>
        <div class="campus-item">
          <el-image :src="campus_welfare" class="campus-img"></el-image>
        </div>
        <div class="campus-item-job">
          <el-row :gutter="0" style="margin-top: 10%">
            <el-col v-for="job in job_list" :span="8" :key="job.name">
              <router-link :to="'/join_social_details?job_name='+job.name" style="position:relative;">
                <el-image :src="'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/'+ job.name +'.png'"
                          style="margin: 4% 0; position: relative;">
                </el-image>
              </router-link>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class='social-bg' v-show="$i18n.locale==='en'">
      <el-image :src="campus_header_en" style=" width: 100%; margin-bottom: 3%"></el-image>
      <div class="campus-item">
        <el-image :src="social_en" class="campus-img"></el-image>
      </div>
      <img src="../assets/img_grande/submit.png" alt="" class="new-submit-btn" @click="dialogFormVisible = true">
    </div>
    <el-dialog title="Basic Information" :visible.sync="dialogFormVisible" class="en-dialog-upload">
      <el-form label-position="left" :model="form" :rules="rules">
        <div class="dialog-upload-form">
          <el-form-item label="NAME:" prop="name" label-width="80px">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="TEL:" prop="telephone" label-width="80px">
            <el-input v-model="form.telephone"></el-input>
          </el-form-item>
          <el-form-item label="DESIRED POSITION:" prop="job_name" label-width="47.5%">
            <el-select v-model="form.job_name" placeholder="">
              <el-option v-for="job in job_name_list" :label="job.value" :value="job.value"
                         :key='job.value'></el-option>
            </el-select>
          </el-form-item>
          <div style="width: 80%;margin: auto;">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="https://grandegames.com//api/upload_emails"
              :on-exceed="handleExceed"
              :data="form"
              :on-success="fileUploadSuccess"
              :on-error="fileUploadFail"
              :before-upload="beforeAvatarUpload">
              <el-button size="small" type="primary">Submit resume</el-button>
            </el-upload>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        //和校园招聘引入资源基本相同
        campus_header: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_header.jpg',
        campus_header_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_header_en_new.jpg',
        // social_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/social_en.png',
        social_en: `${require('../assets/img_grande/new_social_center.png')}`,
        social_title: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/social_title.png',
        campus_welfare: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_welfare.png',
        campus_up: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_up.png',
        job_list: [],
        form: {
          name: '',
          job_name: '',
          telephone: '',
        },
        dialogFormVisible: false,
        rules: {
          name: [
            {required: true, message: 'please input', trigger: 'blur'},
          ],
          telephone: [
            {required: true, message: 'please input', trigger: 'blur'},
            {min: 11, max: 11, message: 'please input ', trigger: 'blur'},
          ],
          job_name: [
            {required: true, message: 'please select', trigger: 'blur'},
          ],
        },
        job_name_list: [
          {value: '2D ARTIST'},
          {value: 'BACK-END DEVELOPER'},
          {value: 'COCOS2D-X DEVELOPER'},
          {value: 'DATA SCIENCE'},
          {value: 'GAME DESIGNER'},
          {value: 'UI ARTIST'},
          {value: 'USER ACQUISITION'},
          {value: 'VIDEO DESIGNER'},
          {value: 'UNITY DEVELOPER'}
        ],
        cur_per: 0,
        pro_show: true
      }
    },
    created() {
      this.getJson();
    },
    methods: {
      getJson() {
        const json = require('../assets/json/campus_job.json');
        const data = Object.keys(json);
        this.job_list = data.map((item) => {
          return {name: item};
        })
      },
      handleExceed(files, fileList) {
        this.$message.warning(`Limit three files`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`Remove ${file.name}？`);
      },
      fileUploadSuccess() {
        this.fileList = [];
        setTimeout(() => {
          this.cur_per = 100;
          this.dialogFormVisible = false;
          this.upload_file_success = true;
          setTimeout(() => {
            alert('success!');
            this.pro_show = true;
            this.cur_per = 0;
            this.$refs.upload.clearFiles();
            this.form = {
              name: '',
              ob_name: '',
              telephone: '',
            }
          }, 700);
        }, 300);
      },
      fileUploadFail() {
        console.log('Failed');
      },
      beforeAvatarUpload(file) {
        const FileExt = file.name.replace(/.+\./, '');
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (['jpg', 'jpeg', 'png', 'txt', 'pdf', 'doc', 'docx'].indexOf(FileExt.toLowerCase()) === -1) {
          alert('File type:jpg、jpeg、png、txt、pdf、doc、docx');
          return false;
        } else if (!isLt2M) {
          alert('Limit 10MB!');
          return false;
        } else {
          this.pro_show = false;
          var timer = setInterval(() => {
            this.cur_per += Math.ceil(Math.random() * 30);
            console.log(this.cur_per)
            if (this.cur_per >= 60) {
              clearInterval(timer);
            }
          }, 300);
          return true;
        }
      },
      changeStatus() {
        this.dialogFormVisible = true;
        if (this.upload_file_success) {
          this.$refs.upload.clearFiles();
        }
      },
    }
  }
</script>

<style lang="less">
  .progress-show {
    display: none;
  }

  .my-progress {
    background: rgba(0, 0, 0, 0.9);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 3000;

    .progress-circle {
      top: 40%;
    }
  }

  .campus-item, .campus-item-job {
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
  }

  .campus-item {
    width: 90%;
  }

  .campus-item-job {
    width: 60%;
  }

  .campus-img {
    width: 100%;
  }

  .new-submit-btn {
    width: 30vw;
    margin-top: 30px;
    cursor: pointer;
  }

  .en-dialog-upload {
    width: 45%;
    margin: 0 auto;
  }

  @media screen and (max-width: 992px) {
    .campus-item {
      width: 120%;
      position: relative;
      right: 10%;
    }

    .campus-item, .campus-item-job {
      margin-top: 20px;
    }

    .campus-item-job {
      width: 80%;
    }

    .en-dialog-upload {
      width: 100%;
    }

    .el-form-item__label {
      font-size: 12px;
    }

    .new-submit-btn {
      width: 50vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/JoinUsSocial.vue